const STORAGE_KEY = 'uptime-lang';

export const SUPPORTED_LOCALES = ['zh', 'en'];

const messages = {
  zh: {
    themeToggleAria: '切换深浅色模式',
    themeDark: '深色',
    themeLight: '浅色',
    statusOk: '正常',
    statusDown: '异常',
    statusUnknown: '未知',
    errorTooManyRequests: '请求过于频繁，请稍后再试。',
    errorLoadFailed: '数据加载失败，请稍后刷新。',
    notice: '提示',
    retry: '重试',
    today: '今天',
    recentDays: '最近 {{days}} 天',
    incidentsAndDuration: '故障 {{times}} 次，累计 {{duration}}，平均可用率 {{average}}%',
    uptimeOnly: '可用率 {{average}}%',
    viewProjectOnGithub: '在 {{github}} 上查看此项目',
    languageLabel: '语言',
    languageChinese: '中文',
    languageEnglish: 'English',
  },
  en: {
    themeToggleAria: 'Toggle theme',
    themeDark: 'Dark',
    themeLight: 'Light',
    statusOk: 'Up',
    statusDown: 'Down',
    statusUnknown: 'Unknown',
    errorTooManyRequests: 'Too many requests. Please try again later.',
    errorLoadFailed: 'Failed to load data. Please refresh later.',
    notice: 'Notice',
    retry: 'Retry',
    today: 'Today',
    recentDays: 'Last {{days}} days',
    incidentsAndDuration: '{{times}} incidents, total {{duration}}, average uptime {{average}}%',
    uptimeOnly: 'Average uptime {{average}}%',
    viewProjectOnGithub: 'View this project on {{github}}',
    languageLabel: 'Language',
    languageChinese: '中文',
    languageEnglish: 'English',
  }
};

function normalizeLocale(value) {
  if (!value || typeof value !== 'string') return 'zh';
  const lower = value.toLowerCase();
  if (lower.startsWith('zh')) return 'zh';
  if (lower.startsWith('en')) return 'en';
  return 'zh';
}

export function getInitialLocale() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch (error) {
    // ignore storage access errors and fallback to browser language
  }
  return normalizeLocale(window.navigator.language);
}

export function persistLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch (error) {
    // ignore storage write errors
  }
}

export function t(locale, key, params = {}) {
  const dict = messages[locale] || messages.zh;
  const fallback = messages.zh[key] || key;
  const template = dict[key] || fallback;
  return template.replace(/\{\{(\w+)\}\}/g, (_, token) => {
    const value = params[token];
    if (value === undefined || value === null) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(`[i18n] Missing template param "${token}" for key "${key}"`);
      }
      return '';
    }
    return String(value);
  });
}
